export default (value) => {
  if(value) return false;
  else return { 
    title: 'ไม่พบข้อมูล',
    color: 'gray',
    caption: 'ไม่พบข้อมูลนี้ในฐานข้อมูล',
    suggest: 'โปรดเพิ่มข้อมูลลงในฐานข้อมูล'
  };
}